export const CLEAR = 'CLEAR'

export const clearStore = () => ({
  type: CLEAR,
})
